const icons = require(`@ant-design/icons`);

const DynamicIcon = ({ name, ...props }) => {
  const Icon = icons[name];
  return Icon ? <Icon {...props} /> : ""
};

export default DynamicIcon;